import React, { useEffect, useState } from 'react';
import '../../css/AdminTable.css';
import { BACKEND_URL } from '../../config';

const OrdersAdmin = () => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [deletingId, setDeletingId] = useState(null);

    useEffect(() => {
        fetchOrders();
        // eslint-disable-next-line
    }, []);

    const fetchOrders = () => {
        setLoading(true);
        const token = localStorage.getItem('authToken');
        fetch(`${BACKEND_URL}/orders`, {
            headers: token ? { 'Authorization': `Bearer ${token}` } : {}
        })
            .then(res => {
                if (!res.ok) throw new Error('Не вдалося завантажити замовлення');
                return res.json();
            })
            .then(setOrders)
            .catch(err => setError(err.message))
            .finally(() => setLoading(false));
    };

    const handleDelete = async (orderId) => {
        setDeletingId(orderId);
        const token = localStorage.getItem('authToken');
        try {
            const res = await fetch(`${BACKEND_URL}/orders/${orderId}`, {
                method: 'DELETE',
                headers: token ? { 'Authorization': `Bearer ${token}` } : {}
            });
            if (!res.ok) throw new Error('Не вдалося видалити замовлення');
            fetchOrders();
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <div>
            <h2>Активні замовлення</h2>
            {loading && <div>Завантаження...</div>}
            {error && <div className="error-message">{error}</div>}
            {!loading && !error && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
                    {orders.length === 0 ? (
                        <div style={{textAlign: 'center'}}>Немає замовлень</div>
                    ) : (
                        orders.map(order => (
                            <div key={order.id} style={{
                                background: '#fff',
                                borderRadius: 8,
                                boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
                                padding: 24,
                                marginBottom: 0,
                                border: '1px solid #eee',
                                maxWidth: 600,
                                position: 'relative'
                            }}>
                                <button
                                    onClick={() => handleDelete(order.id)}
                                    disabled={deletingId === order.id}
                                    style={{
                                        position: 'absolute',
                                        top: 16,
                                        right: 16,
                                        background: '#d9534f',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: 4,
                                        padding: '6px 12px',
                                        cursor: 'pointer',
                                        fontWeight: 500,
                                        fontSize: 14
                                    }}
                                    title="Видалити замовлення"
                                >
                                    {deletingId === order.id ? '...' : 'Видалити'}
                                </button>
                                <div style={{fontWeight: 600, fontSize: 18, marginBottom: 8}}>
                                    {order.userName || <span style={{color:'#888'}}>Без імені</span>}
                                </div>
                                <div style={{marginBottom: 12, color: '#555'}}>
                                    <span style={{fontWeight: 500}}>Телефон:</span> {order.phoneNumber}
                                </div>
                                <div style={{marginBottom: 10, fontWeight: 500}}>Товари:</div>
                                <div style={{marginBottom: 10}}>
                                    {order.orderItems && order.orderItems.length > 0 ? (
                                        <ul style={{paddingLeft: 18, margin: 0}}>
                                            {order.orderItems.map(item => (
                                                <li key={item.id} style={{marginBottom: 6}}>
                                                    <div><b>{item.productName}</b></div>
                                                    <div style={{fontSize: 14, color: '#444'}}>
                                                        ID: {item.productId} | Кількість: {item.quantity} | Ціна: {item.price} грн
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <div style={{color:'#888'}}>Немає товарів</div>
                                    )}
                                </div>
                                <div style={{fontSize: 13, color: '#888'}}>
                                    ID замовлення: {order.id}
                                </div>
                            </div>
                        ))
                    )}
                </div>
            )}
        </div>
    );
};

export default OrdersAdmin;